import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
}

export const Card: React.FC<CardProps> = ({ 
  children, 
  className = '',
  hover = true
}) => {
  const hasBg = className.includes('bg-');
  const hasBorder = className.includes('border-');
  
  return (
    <div className={`${hasBg ? '' : 'bg-white'} ${hasBorder ? '' : 'border border-slate-200'} rounded-sm overflow-hidden ${hover ? 'card-hover-lift' : ''} ${className}`}>
      {children}
    </div>
  );
};
